export default __webpack_public_path__ + "static/media/tab_grid.86d4901b.svg";